import { createAsyncThunk } from '@reduxjs/toolkit'

import { App } from '@/apps'

export const switchApp = createAsyncThunk('switch-app', async (app: App | undefined) => app)
